<template>
  <panel-section
    class="ai-visibility-citation-sources-panel"
    :title="title"
    :subtitle="subtitle"
    card-class="ai-visibility-citation-sources-panel__card"
  >
    <div class="ai-visibility-citation-sources-panel__head">
      <span>Domains</span>
      <span>Times cited</span>
    </div>
    <citation-source-row
      v-for="row in citations.rows"
      :key="row.domain"
      :row="row"
    />
    <panel-action-link
      class="ai-visibility-citation-sources-panel__action"
      :to="actionTo"
      @click="$emit('view-all')"
    >
      {{ actionLabel }}
    </panel-action-link>
  </panel-section>
</template>

<script>
import PanelActionLink from '../../../ui/cards/PanelActionLink.vue'
import PanelSection from '../../../ui/cards/PanelSection.vue'
import CitationSourceRow from './CitationSourceRow.vue'

export default {
  name: 'CitationSourcesPanel',
  components: {
    PanelActionLink,
    PanelSection,
    CitationSourceRow,
  },
  props: {
    title: {
      type: String,
      default: 'Where AI finds information about you',
    },
    subtitle: {
      type: String,
      default: '',
    },
    citations: {
      type: Object,
      required: true
    },
    actionTo: {
      type: [Object, String],
      default: null,
    }
  },
  computed: {
    actionLabel () {
      return 'View all sources'
    }
  }
}
</script>

<style lang="scss" scoped>

.ai-visibility-citation-sources-panel__card {
  min-height: 340px;
}

.ai-visibility-citation-sources-panel__head {
  display: flex;
  justify-content: space-between;
  color: var(--v-mainColor3-base);
  padding: 0 0 14px;
  border-bottom: 1px solid var(--v-gray13Color-base);

  span {
    font-size: 16px;
    font-weight: 700;
  }
}

.ai-visibility-citation-sources-panel__action {
  margin-top: 16px;
}
</style>
